import React, { useEffect, useState } from 'react';
import {
  Container,
  Typography,
  Box,
  Card,
  Button,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Grid,
  Alert,
} from '@mui/material';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const SpacePlanning = () => {
  const [projects, setProjects] = useState([]);
  const [selectedProject, setSelectedProject] = useState('');
  const [spaceType, setSpaceType] = useState('rental');
  const [dimensions, setDimensions] = useState({
    length: '',
    width: '',
    height: '',
  });
  const [layout, setLayout] = useState(null);

  useEffect(() => {
    fetchProjects();
  }, []);

  const fetchProjects = async () => {
    try {
      const response = await axios.get(`${API_URL}/projects`);
      setProjects(response.data.projects || []);
    } catch (error) {
      console.error('Error fetching projects:', error);
    }
  };

  const handleGenerate = async () => {
    try {
      const response = await axios.post(`${API_URL}/space-planning/generate`, {
        project_id: selectedProject,
        space_type: spaceType,
        dimensions: {
          length: parseFloat(dimensions.length),
          width: parseFloat(dimensions.width),
          height: parseFloat(dimensions.height),
        },
      });
      setLayout(response.data.layout);
    } catch (error) {
      console.error('Error generating layout:', error);
    }
  };

  return (
    <Container sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Space Planning
      </Typography>

      <Card sx={{ mt: 3, p: 3 }}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <FormControl fullWidth margin="normal">
              <InputLabel>Select Project</InputLabel>
              <Select
                value={selectedProject}
                onChange={(e) => setSelectedProject(e.target.value)}
                label="Select Project"
              >
                {projects.map((project) => (
                  <MenuItem key={project.id} value={project.id}>
                    {project.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6}>
            <FormControl fullWidth margin="normal">
              <InputLabel>Space Type</InputLabel>
              <Select
                value={spaceType}
                onChange={(e) => setSpaceType(e.target.value)}
                label="Space Type"
              >
                <MenuItem value="rental">Rental Unit</MenuItem>
                <MenuItem value="rebuilt">Rebuilt Home</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="Length (ft)"
              type="number"
              value={dimensions.length}
              onChange={(e) => setDimensions({ ...dimensions, length: e.target.value })}
              margin="normal"
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="Width (ft)"
              type="number"
              value={dimensions.width}
              onChange={(e) => setDimensions({ ...dimensions, width: e.target.value })}
              margin="normal"
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <TextField
              fullWidth
              label="Height (ft)"
              type="number"
              value={dimensions.height}
              onChange={(e) => setDimensions({ ...dimensions, height: e.target.value })}
              margin="normal"
            />
          </Grid>
        </Grid>
        <Box mt={3}>
          <Button variant="contained" onClick={handleGenerate} disabled={!selectedProject}>
            Generate Layout
          </Button>
        </Box>
      </Card>

      {layout && (
        <Card sx={{ mt: 3, p: 3 }}>
          <Typography variant="h6" gutterBottom>
            Layout Recommendations
          </Typography>
          {layout.layout_data?.recommendations && (
            <Box mt={2}>
              {layout.layout_data.recommendations.map((rec, index) => (
                <Alert key={index} severity="info" sx={{ mb: 1 }}>
                  {rec}
                </Alert>
              ))}
            </Box>
          )}
          {layout.layout_data?.space_utilization && (
            <Box mt={2}>
              <Typography variant="body1">
                Space Utilization: {layout.layout_data.space_utilization.toFixed(1)}%
              </Typography>
            </Box>
          )}
        </Card>
      )}
    </Container>
  );
};

export default SpacePlanning;

